<template>
  <div :class="{avatar: true, border, cursor, full}" @click="onClick" :style="{ 'backgroundColor': getColor }">
    <Loader color="white" :auto="true" v-if="loading"/>
    <div class="letter" v-if="!loading && !getImage">{{ getLetter }}</div>
  </div>
</template>

<script>
import axios from 'axios'
import Loader from '@/components/Loader'

export default {
  name: 'Avatar',
  props: {
    border: Boolean,
    cursor: Boolean,
    full: Boolean,
    externalData: Object
  },
  components: {
    Loader
  },  
  data() {
    return {
      loading: true,
      userData: null
    }
  },
  methods: {
    loadUserData() {
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}loadUserData`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        }
      }).then(result => {
        this.userData = result.data.user;
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        console.log(err);
        alert.showError(err);
      })
    },
    onClick() {
      this.$emit('onClick');
    }
  },
  computed: {
    getLetter() {
      let name = this.userData.nick;
      let nameArray = name.split(' ');
      let letters = '';
      nameArray.forEach(element => {
        if(letters.length < 2) {
          letters += element[0];
        }
      });
      return letters.toUpperCase();
    },
    getColor() {
      let color= null;
      if(this.userData) {
        if(this.userData.plan == 'basic') {
          color = '#11b6a5';
        }
        if(this.userData.plan == 'silver') {
          color = '#cccccc';
        }
        if(this.userData.plan == 'gold') {
          color = '#ebc659';
        }
      }
      return color;
    },
    getImage() {
      return this.userData.profilePircture;
    }
  },
  created() {
    if(!this.externalData) {
      this.loadUserData();
    } else {
      this.userData = this.externalData;
      this.loading = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;

  .letter {
    font-weight: bold;
  }
}

.border {
  border: 2px solid #0f9789a2;
}

.cursor {
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    border: 2px solid #0f9789;
  }
}

.full {
  width: 100%;
  height: 100%;
}

//Loader
.spinner {
  width: 100%;
  height: 100%;
  position: relative;
}

.double-bounce1, .double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: white;
  opacity: 0.3;
  position: absolute;
  top: 0;
  left: 0;
  
  -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
  animation: sk-bounce 2.0s infinite ease-in-out;
}

.double-bounce2 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

@-webkit-keyframes sk-bounce {
  0%, 100% { -webkit-transform: scale(0.0) }
  50% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bounce {
  0%, 100% { 
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  } 50% { 
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
}
</style>